// extracted by mini-css-extract-plugin
export var container = "notification-settings-module--container--5UVtR";
export var header = "notification-settings-module--header--NBKqm";